import { getRequest, putRequest, getRequestV5, postRequest } from './rest'
import { ALL_ORGS_SELECTED } from 'lib/constants'

export const getFloors = (orgId: string): Promise<any[]> => {
  return getRequest({
    endpoint: `api/v5/floors`,
    header: orgId === ALL_ORGS_SELECTED ? {} : { org_id: orgId },
  })
    .then((response: any) => {
      return response.data.data
    })
    .catch((error: Error) => {
      console.error('Error fetching floors:', error)
      throw error
    })
}
